 // 过滤器写法:
 //  {{order.woStat | dict('PRODUCTION_WO_STATUS')}}
  
 //  当方法调用,获得字典数据列表,用于做picker的选项列表:
 //  this.stateArray = dictFormat(null, 'PRODUCTION_WO_STATUS', 1);


import dictJsonBk from "@@/assets/js/dictJsonBk.js";
import _this from '@@/main.js';

let dictJson = dictJsonBk;
let isInit = false;
export default function(key, dt, type) {
	if (!isInit) {
		let globalDictJson = Vue.prototype.store.state.dictJson;
		if (globalDictJson !== undefined) {
			dictJson = globalDictJson;
			isInit = true;
		}
	}
	if (type == 1) {
		//获取指定分类的字典列表
		dictJson[dt].source.forEach(dict => {
			dict.text =  Vue.prototype.i18n.t(dict.i18nKey);
		})
		return dictJson[dt].source;
	} else {
		let oKey = key;
		key = parseInt(oKey);
		if (key === undefined || key === null || isNaN(key)) {
			console.error('不合法的key值:%s,%s', oKey, dt);
			return;
		}

		if (dictJson[dt] === undefined) {
			console.error('没有这个字典类型:%s,%s', key, dt);
		}

		let value;
		value = dictJson[dt][key];
		//key数据不能匹配字典
		if (value === undefined) {
			console.error('匹配不到的key值:%s,%s', oKey, dt);
			value = key;
		} else {
			value = Vue.prototype.i18n.t(value);
		}
		return value;
	}

}
